import React from "react";
import locations from "../../../../../locale/en/location.json";
import { useTranslation } from "react-i18next";
import { FormBuilder } from "components/FormBuilder/FormBuilder";
import { useWatch } from "react-hook-form";

const PAGE_LOCALE_KEY =
  "page.merchants.merchantDetail.info.merchantInfo.fields";
const NON_HK_OPTIONS = [
  {
    key: "N/A",
    title: "N/A",
    value: "N/A",
  },
]

const LocationCascader = ({
  formProps,
  isEdit,
  isLoading,
}) => {
  const { t } = useTranslation();

  const isDisabled = !isEdit || isLoading;

  // const isHongKong = useWatch({ control: formProps.control, name: "country" }) === "HK";
  const isHongKong = true;
  const area = useWatch({ control: formProps.control, name: "storeArea" });
  const district = useWatch({ control: formProps.control, name: "storeDistrict" });


  const areaOptions = Object.keys(locations).map((area) => ({
    key: area,
    value: area,
    title: area,
  }))

  // Generate options with fallback to form values
  const districtOptions =
    Object.keys(locations[area] || {}).map(
      (district) => ({
        key: district,
        value: district,
        title: district,
      }),
    );

  const subDistrictOptions =
    (locations[area]?.[district] || []).map((sub) => ({
      key: sub,
      value: sub,
      title: sub,
    }))

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    storeArea: {
      fieldType: "selection",
      fieldName: "storeArea",
      label: t(`${PAGE_LOCALE_KEY}.storeArea`),
      mandatory: isHongKong,
      disabled: !isHongKong || isDisabled || areaOptions.length === 0,
      config: {
        options: !isHongKong ? NON_HK_OPTIONS : areaOptions,
        customOnChangeFn: (value, { setValue }) => {
          value && setValue("storeDistrict", null);
          value && setValue("storeSubdistrict", null);
        }
      }
    },
    storeDistrict: {
      fieldType: "selection",
      fieldName: "storeDistrict",
      label: t(`${PAGE_LOCALE_KEY}.storeDistrict`),
      mandatory: isHongKong,
      disabled: !isHongKong || isDisabled || districtOptions.length === 0,
      config: {
        options: !isHongKong ? NON_HK_OPTIONS : districtOptions,
        customOnChangeFn: (value, { setValue }) => {
          value && setValue("storeSubdistrict", null);
        }
      }
    },
    storeSubdistrict: {
      fieldType: "selection",
      fieldName: "storeSubdistrict",
      label: t(`${PAGE_LOCALE_KEY}.storeSubdistrict`),
      mandatory: isHongKong,
      disabled: !isHongKong || isDisabled || subDistrictOptions.length === 0,
      config: {
        options: !isHongKong ? NON_HK_OPTIONS : subDistrictOptions,
      }
    }
  }

  return (
    <FormBuilder.Row itemsPerRow={3}>
      {FormBuilder.buildFields({
        formProps,
        fields: [
          fieldsConfig.storeArea,
          fieldsConfig.storeDistrict,
          fieldsConfig.storeSubdistrict
        ]
      })}
    </FormBuilder.Row>
  );
}

export default React.memo(LocationCascader);